module.exports = __webpack_public_path__ + "c36f1fd4f3bee3aaae1ba89d87f77b27.jpg";